module.exports = __webpack_public_path__ + "static/media/pmi_prep_small.035d41be.jpg";